import { ExternalQuestion } from '@sm/question-widgets/respondent-survey';
import { QuestionAnswers } from '~app/pages/SurveyTaking/types';
import { mapImplicitResponse } from './mapImplicitResponse';
import { mapOpenEndedResponse } from './mapOpenEndedResponse';

import { GetCurrentSurveySessionQuery, QuestionAnswerInput } from '~lib/generatedGqlTypes';

/**
 *
 * @param answers Object containing answers for the current page with questionId as the key
 * @param currentPage Current survey page that user is responding to
 * @param mappedQuestions Array containing questions from current page
 * @returns an array of responses matching the shape expected by mutation, empty responses discarded.
 */

type MapSurveyAnswersArgsType = {
  answers: QuestionAnswers;
  currentPageId: NonNullable<GetCurrentSurveySessionQuery['surveyTakingSession']['respondent']['currentPage']>['id'];
  mappedQuestions: ExternalQuestion[];
};

export const mapSurveyAnswersToResponse = ({
  answers,
  currentPageId,
  mappedQuestions,
}: MapSurveyAnswersArgsType): QuestionAnswerInput[] => {
  return Object.keys(answers)
    .filter(k => answers[k].values?.[0]?.value) // discard empty answers
    .map<QuestionAnswerInput>(key => {
      const answer = answers[key];
      const { questionId } = answer;

      return {
        questionId,
        pageId: currentPageId,
        openEnded: mapOpenEndedResponse(answer),
        choice: [],
        implicit: mapImplicitResponse(questionId, mappedQuestions),
      };
    });
};

export default mapSurveyAnswersToResponse;
